import React, { useState, useEffect, useRef } from "react";
import two_slider_1 from '../../assets/two_slider_1.avif';
import two_slider_2 from '../../assets/two_slider_2.avif';
import two_slider_3 from '../../assets/two_slider_3.avif';
import two_slider_4 from '../../assets/two_slider_4.avif';
import two_slider_5 from '../../assets/two_slider_5.avif';
import two_slider_6 from '../../assets/two_slider_6.avif';
import two_slider_7 from '../../assets/two_slider_7.avif';
import two_slider_8 from '../../assets/two_slider_8.avif';
import two_slider_9 from '../../assets/two_slider_9.avif';
import two_slider_10 from '../../assets/two_slider_10.avif';
import two_slider_11 from '../../assets/two_slider_11.avif';
import two_slider_12 from '../../assets/two_slider_12.avif';
import two_slider_13 from '../../assets/two_slider_13.avif';

const itemsData = [
  { img: two_slider_1, title: "Вывески", desc: "Фасадные конструкции" },
  { img: two_slider_2, title: "Объёмные буквы", desc: "Светящиеся профили" },
  { img: two_slider_3, title: "Лайтбоксы", desc: "Тонкие короба" },
  { img: two_slider_4, title: "Баннеры", desc: "Широкоформат" },
  { img: two_slider_5, title: "Таблички", desc: "Акрил и металл" },
  { img: two_slider_6, title: "Стенды", desc: "Информационные" },
  { img: two_slider_7, title: "Брендинг авто", desc: "Виниловая оклейка" },
  { img: two_slider_8, title: "Полиграфия", desc: "Визитки и буклеты" },
  { img: two_slider_9, title: "Пенопласт", desc: "Фигурные буквы" },
  { img: two_slider_10, title: "Неон", desc: "Гибкий и стеклянный" },
  { img: two_slider_11, title: "Штендеры", desc: "Уличные стойки" },
  { img: two_slider_12, title: "Флаги", desc: "Виндеры и печать" },
  { img: two_slider_13, title: "Оформление витрин", desc: "Пленка и перфорация" },
];

const STEP_INTERVAL = 2400;
const GAP_PX = 12;
const SLIDES_VISIBLE = 8;

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const InfiniteStepSlider = () => {
  const containerRef = useRef(null);
  const [index, setIndex] = useState(0);
  const [transitionEnabled, setTransitionEnabled] = useState(true);
  const [slideWidth, setSlideWidth] = useState(0);

  const totalSlides = itemsData.length;

  const updateSlideWidth = () => {
    const container = containerRef.current;
    if (container) {
      const containerWidth = container.offsetWidth;
      const calculatedSlideWidth = (containerWidth - GAP_PX * (SLIDES_VISIBLE - 1)) / SLIDES_VISIBLE;
      setSlideWidth(calculatedSlideWidth);
    }
  };

  useEffect(() => {
    updateSlideWidth();
    window.addEventListener("resize", updateSlideWidth);

    const interval = setInterval(() => {
      setIndex((prev) => prev + 1);
      setTransitionEnabled(true);
    }, STEP_INTERVAL);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", updateSlideWidth);
    };
  }, []);

  useEffect(() => {
    if (index === totalSlides) {
      const timeout = setTimeout(() => {
        setTransitionEnabled(false);
        setIndex(0);
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [index, totalSlides]);

  const getTransform = () => {
    if (!slideWidth) return `translateX(0px)`;
    return `translateX(-${index * (slideWidth + GAP_PX)}px)`;
  };

  return (
    <section className="bg-bg pt-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока */}
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Каталог решений
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Комплексный подход к рекламе
            </h2>
          </div>
          
          <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
            Получить консультацию <Icon name="arrow" size={13} />
          </button>
        </div>

        {/* Слайдер на 8 элементов */}
        <div ref={containerRef} className="relative w-full overflow-hidden">
          <div
            className="flex py-1"
            style={{
              transform: getTransform(),
              transition: transitionEnabled ? 'transform 500ms cubic-bezier(0.2, 0.8, 0.2, 1)' : 'none',
              gap: `${GAP_PX}px`,
              width: 'max-content',
            }}
          >
            {[...itemsData, ...itemsData].map((item, i) => (
              <div
                key={i}
                className="group flex flex-col cursor-pointer"
                style={{
                  width: slideWidth > 0 ? `${slideWidth}px` : `calc((100% - ${GAP_PX * (SLIDES_VISIBLE - 1)}px) / ${SLIDES_VISIBLE})`,
                  minWidth: slideWidth > 0 ? `${slideWidth}px` : `calc((100% - ${GAP_PX * (SLIDES_VISIBLE - 1)}px) / ${SLIDES_VISIBLE})`,
                  maxWidth: slideWidth > 0 ? `${slideWidth}px` : `calc((100% - ${GAP_PX * (SLIDES_VISIBLE - 1)}px) / ${SLIDES_VISIBLE})`,
                  flexShrink: 0,
                }}
              >
                <div className="aspect-square w-full overflow-hidden rounded-xl bg-surface border border-line-strong">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="h-full w-full object-cover transition duration-300 group-hover:scale-105"
                  />
                </div>

                <div className="mt-2 text-left">
                  <div className="truncate text-[12px] font-medium leading-tight text-content group-hover:text-accent-hover transition-colors">
                    {item.title}
                  </div>
                  <div className="truncate text-[10px] font-light text-subtle">
                    {item.desc}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default InfiniteStepSlider;